import { useAllSegmentsStore } from "@/pinia/allSegmentsStore";
import { useAppsStore } from "@/pinia/appsStore";
import { useUserStore } from "@/pinia/userStore";
import { PromptTypes } from "./constants/PromoTypesConstants";

export default {
  computed: {
    allSegmentsStore: () => useAllSegmentsStore(),
    segments() {
      return this.allSegmentsStore.segments || [];
    },
    isSandboxLocked() {
      return !!useAppsStore().app?.flags?.sandbox && !useUserStore().isCurrentSuperAdmin;
    },
    testUserSegment() {
      return this.segments.find(seg => seg.segment_type === "system_test_users") ?? null;
    },
    segmentListWithHeaders() {
      const isScheduledPush = this.model?.path_type === PromptTypes.scheduled_push.value;
      return this.segments
        .filter(segment => {
          // scheduled_push paths use a dedicated pinpoint filter; sandbox restriction
          // applies to prompts and guides only, not scheduled_push paths
          if (isScheduledPush) return segment.segment_type === "pinpoint";
          return !this.isSandboxLocked || segment.segment_type === "system_test_users";
        })
        .map(segment => ({ name: segment.name, id: segment.id, rawValue: segment }));
    },
  },
  mounted() {
    if (!this.segments.length) {
      this.allSegmentsStore.getSegments({ appId: this.$route.params.aid });
    }
  },
};
